export default __webpack_public_path__ + "static/ternumBFC-4010dd9e11a871df5e96ac4aefc31403.png";